import React, { useEffect, useState } from 'react';
import { Modal, Tag, message, Tooltip, Spin } from 'antd';
import apiClient from 'services/apiClient';
import { useMyContext } from 'Context/MyContextProvider';

const AssignBadge = ({ visible, badgeData, allBadges, setShow, onClose, getRandomColor, onAssignBadge, report,setList }) => {
    const { api, UserData, authToken } = useMyContext()
    const [selectedBadges, setSelectedBadges] = useState(badgeData || []);
    // const [availableBadges, setAvailableBadges] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        if (visible) {
            setSelectedBadges(badgeData || []);
        }
    }, [badgeData, visible]);

    const handleBadgeToggle = (badge) => {
        // Check if badge is already selected
        const isSelected = selectedBadges.some(b => b.id === badge.id);

        if (isSelected) {
            setSelectedBadges(selectedBadges.filter(b => b.id !== badge.id));
        } else {
            // Check if we've reached the limit of 5 badges
            if (selectedBadges.length >= 5) {
                message.warning('You can select a maximum of 5 badges');
                return;
            }
            setSelectedBadges([...selectedBadges, badge]);
        }
    };
    useEffect(() => {
        if (badgeData && badgeData.length > 0) {
            setSelectedBadges(badgeData);
        }
    }, [badgeData, visible]);

    const handleSave = async () => {
        try {
            setSaving(true);
            const payload = {
                user_id: UserData?.id,
                report_id: report?.number,
                badge_ids: selectedBadges.map(badge => badge?.id)
            }
            const response = await apiClient.post(`${api}reports/${report?.number}/badges`, payload, {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            });

            if (response.data.status) {
                const data =  response.data?.report_has_badges?.report_has_badges
                const formattedBadges = data?.map(item => item.badge);
                if (report && setList) {
                    setList(prevList => prevList.map(item => 
                        item.number === report.number 
                            ? { ...item, badges: formattedBadges }
                            : item
                    ));
                }
                onAssignBadge();
                message.success('Badges assigned successfully');
                onClose(); // Close modal and refresh badges
            } else {
                message.error(response.data.message || 'Failed to assign badges');
            }
        } catch (error) {
            console.error('Error assigning badges:', error);
            message.error('Failed to assign badges: ' + (error.message || 'Unknown error'));
        } finally {
            setSaving(false);
        }
    };


    return (
        <Modal
            title="Assign Badges"
            open={visible}
            onOk={handleSave}
            onCancel={onClose}
            okButtonProps={{ loading: saving }}
            cancelButtonProps={{ disabled: saving }}
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Spin />
                </div>
            ) : (
                <div>
                    <h4>Available Badges:</h4>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
                        {allBadges?.map((badge, idx) => (
                            <Tooltip key={badge.id} title={badge.description || badge.name || badge.title}>
                                <Tag
                                    color={badge.color || getRandomColor?.(idx)}
                                    style={{
                                        cursor: 'pointer',
                                        opacity: selectedBadges.some(b => b.id === badge.id) ? 1 : 0.6
                                    }}
                                    onClick={() => handleBadgeToggle(badge)}
                                >
                                    {badge.name || badge.title}
                                </Tag>
                            </Tooltip>
                        ))}
                    </div>

                    <h4>Selected Badges: {selectedBadges.length}/5</h4>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                        {selectedBadges.map((badge, idx) => (
                            <Tag
                                key={badge.id}
                                color={badge.color || getRandomColor?.(idx)}
                                closable
                                onClose={(e) => {
                                    e.preventDefault();
                                    handleBadgeToggle(badge);
                                }}
                            >
                                {badge.name || badge.title}
                            </Tag>
                        ))}
                        {selectedBadges.length === 0 && (
                            <div style={{ padding: '8px 0', color: '#999' }}>
                                No badges selected
                            </div>
                        )}
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default AssignBadge;